import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Flex, Typography } from 'antd';
import cn from 'classnames';
import moment from 'moment';

import { Avatar } from '@app/components/Avatar';
import {
  LAST_VISIT,
  U_BRANCH,
  U_KEY,
  U_NAME,
  U_PHONE,
  U_VERSION_FRONTEND,
} from '@app/constants';
import type { NOrganization } from '@app/types/Organization';
import { generateKey, getOsIcon } from '@app/utils';

import type { IconProp } from '@fortawesome/fontawesome-svg-core';

const { Text } = Typography;

export const adaptDataToTable = (
  users: NOrganization.GetUsersResponse['Data']
) => {
  return users.map((user) => {
    const {
      BranchName,
      VersionFrontend,
      LastActivityDate,
      Phone,
      Email,
      FullName,
      Position,
      LastActivityOs,
      Avatar: AvatarPhoto,
      IsDeleted,
    } = user;

    return {
      [U_KEY]: generateKey(Phone, Email),
      [U_NAME]: (
        <div>
          <Flex gap={10} align="center">
            <Avatar
              src={AvatarPhoto}
              nameFirst={FullName}
              className="avatar"
              size={60}
            />
            <div className={cn({ 'deleted-cell': IsDeleted })}>
              <div
                className="name-column-text bold-text"
                data-testid="client-name"
              >
                {FullName}
              </div>
              <div className="name-column-text">{Position}</div>
              {IsDeleted && <Text type="danger">В архиве</Text>}
            </div>
          </Flex>
        </div>
      ),
      [U_PHONE]: (
        <div className={cn({ 'deleted-cell': IsDeleted })}>
          <Text data-testid="client-phone">{Phone ? `+${Phone}` : ''}</Text>
          <br />
          <Text data-testid="client-email">{Email}</Text>
        </div>
      ),
      [U_BRANCH]: (
        <div
          className={cn({ 'deleted-cell': IsDeleted })}
          data-testid="client-branch"
        >
          {BranchName}
        </div>
      ),
      [LAST_VISIT]: (
        <div className={cn({ 'deleted-cell': IsDeleted })}>
          {LastActivityDate && (
            <Text data-testid="client-activity">
              {
                <FontAwesomeIcon
                  icon={getOsIcon(LastActivityOs) as IconProp}
                  size={'lg'}
                />
              }{' '}
              {moment(LastActivityDate, 'DD.MM.YYYY HH:mm:ss').format(
                'DD.MM.YYYY HH:mm'
              )}
            </Text>
          )}
        </div>
      ),
      [U_VERSION_FRONTEND]: (
        <div
          className={cn({ 'deleted-cell': IsDeleted })}
          data-testid="client-update-time"
        >
          {VersionFrontend &&
            moment(VersionFrontend).format('DD.MM.YYYY HH:mm')}
        </div>
      ),
    };
  });
};
